import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionTitle } from "@/components/GlassBits";
import { formatINR, formatDate, statusBadgeClass } from "@/lib/format";
import { Search } from "lucide-react";

export default function PaymentsLog() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");

  const load = useCallback(async () => {
    const p = { params: {} };
    if (q) p.params.q = q;
    if (status) p.params.status = status;
    try {
      const { data } = await api.get("/admin/payments", p);
      setItems(data);
    } catch (e) {
      console.error("[PaymentsLog] load failed", e);
    }
  }, [q, status]);
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [load]);

  return (
    <div>
      <SectionTitle eyebrow="Ledger" title="Payments Log" />
      <div className="ldc-glass p-3 mb-4 flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search invoice, email, phone, RRN…" className="ldc-input w-full pl-9 pr-3 py-2 rounded-md text-sm" data-testid="pay-search" />
        </div>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="ldc-input rounded-md px-3 py-2 text-sm" data-testid="pay-status">
          <option value="">All</option>
          <option value="captured">Captured</option>
          <option value="authorized">Authorized</option>
          <option value="refunded">Refunded</option>
          <option value="failed">Failed</option>
        </select>
      </div>
      <div className="ldc-glass overflow-hidden">
        <div className="overflow-x-auto ldc-scroll">
          <table className="w-full ldc-table" data-testid="payments-table">
            <thead>
              <tr>
                <th>Payment ID</th>
                <th>Invoice</th>
                <th>Customer</th>
                <th>Method</th>
                <th>Amount</th>
                <th>Fee / Tax</th>
                <th>Status</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr><td colSpan={8} className="text-center py-10 text-white/40">No payments captured yet.</td></tr>
              )}
              {items.map((p) => (
                <tr key={p.payment_id} data-testid={`pay-row-${p.payment_id}`}>
                  <td className="font-mono text-xs">{p.payment_id}</td>
                  <td className="font-mono text-[#fbce18]">{p.invoice_no || "—"}</td>
                  <td>
                    <div className="text-white/90 text-sm">{p.customer_name || "—"}</div>
                    <div className="text-[11px] text-white/40">{p.email || p.phone}</div>
                  </td>
                  <td>
                    <div className="uppercase text-xs tracking-[0.14em]">{p.method || "—"}</div>
                    {p.vpa && <div className="text-[11px] text-white/40">{p.vpa}</div>}
                    {p.rrn && <div className="text-[11px] text-white/40">RRN {p.rrn}</div>}
                  </td>
                  <td className="font-medium">{formatINR(p.amount)}</td>
                  <td className="text-xs text-white/60">{formatINR(p.fee)} / {formatINR(p.tax)}</td>
                  <td><span className={statusBadgeClass(p.status)}>{p.status}</span></td>
                  <td className="text-xs text-white/50">{formatDate(p.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
